import { apiFetch } from './apiFetch';

const API_BASE = process.env.REACT_APP_API_URL;

export async function fetchSubscriptions(planId, skip = 0) {
  const res = await apiFetch(`${API_BASE}/admin/subscription/?pid=${planId}&skip=${skip}`);
  return res.json();
}

export async function addSubscriptionsToPlan(planId, startDate, endDate, count) {
  const res = await apiFetch(`${API_BASE}/admin/subscription`, {
    method: 'POST',
    body: JSON.stringify({ planId, startDate, endDate, count })
  });
  return res.json();
}

export async function deleteSubscription(subscriptionId) {
  const res = await apiFetch(`${API_BASE}/admin/subscription/${subscriptionId}`, { method: 'DELETE' });
  return res.json();
}

export async function cancelSubscription(subscriptionId) {
  const res = await apiFetch(`${API_BASE}/admin/subscription/${subscriptionId}/cancel`, { method: 'POST' });
  return res.json();
}

export async function fetchSubscription(subscriptionId) {
  const res = await apiFetch(`${API_BASE}/admin/subscription/${subscriptionId}`);
  return res.json();
}

export async function verifyUserSubscription(subscriptionId) {
  const res = await apiFetch(`${API_BASE}/admin/subscription/${subscriptionId}/verify`, { method: 'POST' });
  return res.json();
}

export async function updateSubscriptionNotes(subscriptionId, internalNotes) {
  const res = await apiFetch(`${API_BASE}/admin/subscription/${subscriptionId}/notes`, {
    method: 'PUT',
    body: JSON.stringify({ internalNotes })
  });
  return res.json();
}

export async function sendSubscriptionLink(subscriptionId, email) {
  const res = await apiFetch(`${API_BASE}/admin/subscription/${subscriptionId}/send-link`, {
    method: 'POST',
    body: JSON.stringify({ email })
  });
  return res.json();
}
